import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import useDecode from "hooks/useDecode";
import {
    GridComponent,
    ColumnsDirective,
    ColumnDirective,
    Page,
    Sort,
    Inject,
} from "@syncfusion/ej2-react-grids";
import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorDisplay";
import SolicitudVolanteAsistencia from "./SolicitudVolanteAsistencia";

const GridSolicitudVolanteAsistencia = () => {
    // const { dataGetModelo145ItByUser, getModelo145ItByUser, successGetModelo145ItByUser } = useGetModelo145ItByUser()
    // const { getInfoModelo145It, infoModelo145It, loadingGetInfoModelo145It, successGetInfoModelo145It } = useGetInfoModelo145It()
    const title = 'Solicitud Volante de Asistencia' // CAMBIAR TITULO
    const history = useHistory();

    /// OBTENER TOKEN PARA LAS PETICIONES ///
    const tokenResponse = useDecode("token");
    const userId = tokenResponse && tokenResponse.extension_id;

    const [arrData, setArrData] = useState(null)
    const [dataUser, setDataUser] = useState(null);
    const [info, setInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [sortingOptions] = useState({
        columns: [{ field: "created", direction: "Descending" }],
    });
    let pageOptions = {
        pageSize: 10,
        pageSizes: ["5", "10", "15", "20", "Todos"],
    };
    const rowSelected = (args) => { // SELECCIONAR UN FORMULARIO E IMPRIMIRLO
        setInfo(false)
        setLoading(true)
        setShow(false)
        setTimeout(() => { //Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);

        const selectedData = args.data;
        setDataUser(selectedData);

    };
    useEffect(() => {
        //getModelo145ItByUser(userId); Agregat el Get Necesario para obtener TODOS los formularios de este tipo (LA TABLA DE FORMULARIOS)
    }, [])

    const handleInfo = () => { //OBTENER INFORMACION EN EL BOTON
        setLoading(true)
        setInfo(true)
        setShow(false)


        setDataUser({ Observaciones: "Hola", FechaAceptacionSolicitud: "", RazonSocial: "COLORES AZULADOS S.L" }) //Agregar el Get Necesario
        // getInfoModelo145It(userId, setDataUser) //Agregar el Get Necesario


        if (dataUser) {
            console.log(dataUser)
            setTimeout(() => { //Darle tiempo actualizar el DOM
                setShow(true)
                setLoading(false)
            }, 200);
        }
    }

    useEffect(() => { // CUANDO CAMBIA DATAUSER SE RECARGA EL FORMULARIO
        setLoading(true)
        setShow(false)
        setTimeout(() => {//Darle tiempo actualizar el DOM
            setShow(true)
            setLoading(false)
        }, 200);
    }, [dataUser]);




    // useEffect(() => {
    //     if (successGetModelo145ItByUser) {
    //         setArrData(dataGetModelo145ItByUser);
    //     }
    // }, [dataGetModelo145ItByUser]);




    useEffect(() => {
        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            console.log(!hasFormZero)
            setShowGenerateButton(!hasFormZero);
        }
    }, [arrData]);

    return (
        <div className="container bg-#EEEEEE">
            <PageMenu title={title} >
                <div className="btns-header-container">
                    <button onClick={() => history.goBack()}>
                        <img src={IconArrowGray} alt="icon arrow right" />
                    </button>
                </div>
            </PageMenu>
            <GridComponent
                dataSource={arrData && arrData}
                allowPaging={true}
                allowSorting={true}
                rowSelected={rowSelected}
                pageSettings={pageOptions}
                //sortSettings={sortingOptions}
                enablePersistence={false}
            >
                <ColumnsDirective>
                    <ColumnDirective
                        field="CodigoExpediente"
                        headerText="Expediente"
                        width="100"
                        textAlign="Center"
                    />
                    <ColumnDirective
                        field="EstadoFormularioDescripcion"
                        headerText="Estado"
                        width="100"
                        textAlign="Center"
                    />
                    <ColumnDirective
                        field="FechaAceptacionSolicitud"
                        headerText="Fecha aceptación"
                        type="date"
                        format="dd/MM/yyyy"
                        width="100"
                    />
                </ColumnsDirective>
                <Inject services={[Page, Sort]} />
            </GridComponent>
            {showGenerateButton && (
                <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={() => handleInfo()}>
                        Generar Formulario
                    </button>
                </div>
            )}
            <Loader activeLoader={loading} label="Cargando Formulario"></Loader>
            {dataUser && (dataUser?.BoolResultado !== false) && show && (
                <div className="mt-5">
                    <SolicitudVolanteAsistencia
                        dataUser={dataUser}
                        info={info} />
                </div>
            )}
            {dataUser && show && dataUser?.BoolResultado === false &&
                <ErrorDisplay descripcionError={dataUser.Descripcion} />
            }

        </div>
    );
};
export default GridSolicitudVolanteAsistencia;
